import { extend } from 'underscore';
import { uiblockerStyle, glyphIconStyle, helpbuttonStyle, inputFieldStyle, buttonInputStyle } from '@bingads-webui-campaign-react/common-styles';

import { getCommonStyle, importUiBlockerStyle } from './common-style';

export const getImportCredentialIDStyle = (_, { palette = {} }) => ({
  '@global': extend(
    {},
    uiblockerStyle({ palette }),
    glyphIconStyle({ palette }),
    helpbuttonStyle({ palette }),
    inputFieldStyle({ palette }),
    importUiBlockerStyle({ palette })
  ),
  ...getCommonStyle({ palette }),
  importCredentialIdPage: extend(
    {},
    buttonInputStyle({ palette }),
    {
      '& .form-group': {
        marginBottom: 26,
      },
      '& span.google-account-name, a.signout, .userid-text-input, .userid-submit-button': {
        display: 'inline-block',
      },
      '& .userid-text-input': {
        minWidth: 500,
      },
      '& a.signout': {
        marginLeft: 18,
      },
      '& .credential-id-text-copy-row, .user-id-setting-row, .user-id-text-row': {
        marginTop: 7,
      },
      '& .credential-id-text': {
        display: 'inline-block',
        height: 32,
        padding: '6px 8px',
        width: 300,
        'background-color': '#F3F2F1',
      },
      '& .copy-button, .userid-submit-button': {
        marginLeft: 12,
      },
    }
  ),
});
